export default class BaseService {  
}
